import { Link } from 'gatsby';
import React, { FC } from 'react';
import styled from 'styled-components';

import Eyebrow from '@ui/atoms/Eyebrow';

import theme from '@theme/FolxTheme';

type ColorVariants = 'black' | 'white';

interface IEyebrowLinkProps {
	label: string;
	to?: string;
	href?: string;
	colorVariant?: ColorVariants;
	className?: string;
	onClick?: () => void;
}

const LinkTextWrapper = styled.div<{ color: string }>`
	border-bottom: 4px solid ${({ color }) => theme.colors[color]};

	&:hover {
		border-bottom-color: ${theme.colors.cyan};
	}

	${Eyebrow} {
		color: ${({ color }) => theme.colors[color]};
		padding-bottom: 0.8rem;
	}
`;

const StyledLink = styled(Link)<{ color: string }>`
	text-decoration: none;
	display: inline-flex;

	&:visited {
		${LinkTextWrapper} {
			border-bottom-color: ${theme.colors.cyan};
		}

		${Eyebrow} {
			color: ${({ color }) => theme.colors[color]};
		}
	}
`;

const StyledAnchor = styled.a<{ color: string }>`
	text-decoration: none;
	display: inline-flex;

	&:visited {
		${LinkTextWrapper} {
			border-bottom-color: ${theme.colors.cyan};
		}

		${Eyebrow} {
			color: ${({ color }) => theme.colors[color]};
		}
	}
`;

const EyebrowLink: FC<IEyebrowLinkProps> = ({
	label,
	to,
	href,
	colorVariant = 'black',
	className = '',
	onClick = () => {},
}) => {
	if (to) {
		return (
			<StyledLink onClick={onClick} to={to} className={className} color={colorVariant}>
				<LinkTextWrapper color={colorVariant}>
					<Eyebrow>{label}</Eyebrow>
				</LinkTextWrapper>
			</StyledLink>
		);
	}

	return (
		<StyledAnchor href={href} className={className} color={colorVariant}>
			<LinkTextWrapper color={colorVariant}>
				<Eyebrow>{label}</Eyebrow>
			</LinkTextWrapper>
		</StyledAnchor>
	);
};

export default styled(EyebrowLink)``;
